import axios, {AxiosRequestConfig} from 'axios';

console.log('env', import.meta.env);

const apiClient = axios.create({
  baseURL: import.meta.env.DEV ? import.meta.env.VITE_API_URL || 'http://entiz.localhost' : '',
  responseType: 'json',
  withCredentials: import.meta.env.PROD,
});

export {apiClient};

async function wrapRequest(asyncFunc: any, ...args: any[]) {
  try {
    const resp = await asyncFunc(...args);
    return resp.data;
  } catch (err: any) {
    console.log('fetch error', err);
    if (err.response?.data) {
      throw err.response?.data;
    } else {
      throw err;
    }
  }
}

export function getRequest(URL: string, config: AxiosRequestConfig | undefined = undefined) {
  if (!URL.startsWith('/')) {
    URL = '/' + URL;
  }
  console.debug('GET ' + URL);
  // return apiClient.get(URL);
  return wrapRequest(apiClient.get, URL, config);
}

export function postRequest(URL: string, payload: any = undefined, config: AxiosRequestConfig | undefined = undefined) {
  if (!URL.startsWith('/')) {
    URL = '/' + URL;
  }
  console.debug('POST ' + URL);
  // return apiClient.post(URL, payload);
  return wrapRequest(apiClient.post, URL, payload, config);
}

export function putRequest(URL: string, payload: any = undefined, config: AxiosRequestConfig | undefined = undefined) {
  if (!URL.startsWith('/')) {
    URL = '/' + URL;
  }
  console.debug('PUT ' + URL);
  // return apiClient.put(URL, payload);
  return wrapRequest(apiClient.put, URL, payload, config);
}

export function patchRequest(URL: string, payload: any = undefined, config: AxiosRequestConfig | undefined = undefined) {
  if (!URL.startsWith('/')) {
    URL = '/' + URL;
  }
  console.debug('PATCH ' + URL);
  // return apiClient.patch(URL, payload);
  return wrapRequest(apiClient.patch, URL, payload, config);
}

export function deleteRequest(URL: string, config: AxiosRequestConfig | undefined = undefined) {
  if (!URL.startsWith('/')) {
    URL = '/' + URL;
  }
  console.debug('DELETE ' + URL);
  // return apiClient.delete(URL);
  return wrapRequest(apiClient.delete, URL, config);
}
